import React, { useEffect, useState } from "react";
import { api } from "../services/api";
import ProductTree from "../components/products/producttree";

export default function Products({ searchResults }) {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    if (!searchResults || searchResults.length === 0) {
      // fetch all products if no search
      api.get("/products").then(res => setProducts(res.data));
    } else {
      setProducts(searchResults);
    }
  }, [searchResults]);

  return <ProductTree initialProducts={products} />;
}